import * as types from '../types/reviewTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  submitOk: false,
};

export default function reviewReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_REVIEWS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_REVIEWS_SUCCESS:
      return { ...state, loading: false, list: action.payload || [] };
    case types.FETCH_REVIEWS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.SUBMIT_REVIEW_DONE:
      return { ...state, submitOk: action.payload };
    default:
      return state;
  }
}
